import { Divider, FormItemsGroup, Modal, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ReceiverName } from './elements/ReceiverName'
import { XRechnungEInvoicingAddress } from './elements/XRechnungEInvoicingAddress'

export const DownloadAsXRechnungModalBody = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal.Body>
      <FormItemsGroup rowSpacing={Spacing.S16}>
        <Text>{t('external_invoices.download_as_xrechnung.modal.description')}</Text>
        <Divider />
        <ReceiverName />
        <XRechnungEInvoicingAddress />
      </FormItemsGroup>
    </Modal.Body>
  )
}
